module.exports = __webpack_public_path__ + "static/media/sparrow_white.7fa64560.png";